import baseClientSideValidation from 'base/components/clientSideValidation';

export const clientSideValidation = {
    ...baseClientSideValidation,

    /**
     * Clear the custom validity and remove the invalid class from the input field.
     */
    input: function () {
        $('form').on('input', function (event) {
            const control = event.target;

            control.setCustomValidity('');
            control.classList.remove('is-invalid');
        });
    },

    /**
     * @override
     *   - Scroll to first invalid field.
     */
    submit() {
        $('form').on('submit', function (event) {
            const {target, currentTarget} = event;

            const isValid = baseClientSideValidation.functions.validateForm(currentTarget, event);

            if (!isValid) {
                const firstInvalidField = currentTarget.querySelector('.is-invalid');
                const scrollTarget = firstInvalidField?.closest('.form-group') || firstInvalidField;

                scrollTarget?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }

            return isValid;
        });
    }
};
